import { useDefaultLayout } from 'react-resizable-panels';

export const useResizablePanelLayout = (storageKey: string) => {
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: storageKey,
    onlySaveAfterUserInteractions: true,
  });

  return { defaultLayout, onLayoutChanged };
};
